import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { mdiBriefcasePlus, mdiArrowLeftCircle } from '@mdi/js';
import { useRouteMatch, Link, Redirect } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import Icon from '@mdi/react';
import PageTitle from '../../../components/PageTitle/PageTitle';
import AccountForm from '../AccountForm/AccountForm';
import { createAccount, startCreateAccount } from '../../../redux/modules/accounts';

const AccountCreate = () => {
    const dispatch                         = useDispatch();
    const { path }                         = useRouteMatch();
    const { t }                            = useTranslation();
    const { account, successfullyCreated } = useSelector(state => state.accounts);

    useEffect(() => {
        dispatch(startCreateAccount());
    }, [dispatch]);

    if (successfullyCreated && account) {
        return <Redirect to={ `edit/${account.id}` } />
    }

    const actions = <Link to={ `${path.replace('new', '')}` }>
        <Button color="info">
            <Icon path={ mdiArrowLeftCircle } size={ 1 } color="white" /> { t('common.back') }
        </Button>
    </Link>;

    const handleAccountCreation = (values) => {
        dispatch(createAccount(values));
    };

    return (
        <div className="AccountCreate">
            <Row>
                <Col>
                    <PageTitle
                        title={ t('accounts.add_title') }
                        icon={ <Icon path={mdiBriefcasePlus} color="white" /> }
                        actions={ actions }
                    />
                </Col>
            </Row>
            <Row>
                <Col xl={{ size: 4, offset: 4 }} md="6">
                    <AccountForm onSubmit={ handleAccountCreation } isCreation={ true } />
                </Col>
            </Row>
        </div>
    );
}

export default AccountCreate;
